import React from 'react';
import { injectIntl } from 'react-intl';
import {
  Button,
  Modal,
  ModalHeader,
  ModalFooter,
  FormGroup,
  Input,
  Row,
  Col,
  Container,
} from 'reactstrap';

import IntlMessage from '../../../helpers/intlMessage';

const CitologiaApagarModalPage = (props) => {

const {messages} = props.intl;

return (

  <Modal size={'ie'} isOpen={props.open} toggle={props.toggle}>
    <ModalHeader toggle={props.toggle}>
      <div>{ messages['dashboards.cytology.deleteBlade'] + props.label}</div>
    </ModalHeader>
    <Container fluid>
      <Row>
        <Col>
          <div style={{ marginTop: '20px', fontSize: '12px' }}>
            <IntlMessage id = "dashboards.cytology.certaintyDelete"/>
          </div>
          <br />
          <FormGroup>
            <Input
              style={{ fontSize: '12px' }}
              type='textarea'
              name='text'
              placeholder={messages['dashboards.examDetail.justificationForCancellation']}
              onChange={props.preencherJustificativaParaCancelamento}
              value={props.justificativaParaCancelamento}
            />
          </FormGroup>
        </Col>
      </Row>
    </Container>
    <ModalFooter>
      <Button color='secondary' onClick={props.toggle}>
        <IntlMessage id = "dashboards.examDetails.cancel"/>
      </Button>
      <Button
        color='primary'
        disabled={
          !props.justificativaParaCancelamento ||
          props.justificativaParaCancelamento.trim().length === 0
        }
        onClick={props.cancelarItem}
      >
         <IntlMessage id = "dashboards.examDetails.confirm"/>
      </Button>
    </ModalFooter>
  </Modal>
  )
};

export default  injectIntl (CitologiaApagarModalPage);



// WEBPACK FOOTER //
// ./src/pages/citologia/content/citologia.apagar.modal.page.js